import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginapiService } from 'src/app/auth/loginapi.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Router, NavigationEnd  } from '@angular/router';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  queryTypeForm: FormGroup
  data: any;
  messages: { text: string; isUser: boolean }[] = [];
  userMessage: string = '';
  isTyping: boolean = false;
  isChatbotOpen: boolean = true;
  chatbotCloseTimer: any;
  quertInput: any;
  loginUser: any;
  multiRoles: any;
  user: any;
  showChatButton = true;
  customConsumer: any;
  @ViewChild('scrollTable', { static: false }) private scrollTable: ElementRef<any>
  users: any;
  constructor(private router: Router,private fb: FormBuilder, private modalService: NgbModal, private loginService: LoginapiService,) { }

  ngOnInit() {
    this.showRole()
     // Check on component load
     const currentUrl = this.router.url;
     this.showChatButton = !currentUrl.startsWith('/adlp/admin/admindashboard/chatBot');
 
     // Also listen to navigation changes
     this.router.events
       .pipe(filter(event => event instanceof NavigationEnd))
       .subscribe((event: NavigationEnd) => {
         const newUrl = event.urlAfterRedirects;
         this.showChatButton = !newUrl.startsWith('/adlp/admin/admindashboard/chatBot');
       });
    this.messages.push({ text: 'Hi there! Thank you for visiting our workspace portal. How can I help you today?', isUser: false });
  }

  chatBot(chatbotContainer: any) {
    const modalRef = this.modalService.open(chatbotContainer, { size: 'sx', windowClass: 'my-window-class' });
    setTimeout(() => {
      modalRef.close();
    }, 180000);
  }

  sendMessage() {
    if (this.userMessage.trim() !== '') {
      this.messages.push({ text: this.userMessage, isUser: true });
      this.datainSertion()
    }
  }

  toggleTyping() {
    this.isTyping = !this.isTyping;
  }

  showRole() {
    let userRolLogin = JSON.stringify(sessionStorage.getItem('userRole'));
    this.user = JSON.parse(userRolLogin);
    this.loginUser = JSON.parse(sessionStorage.getItem('Useremail'));
    this.users = this.loginUser.email
    this.multiRoles = JSON.parse(sessionStorage.getItem('multiRole'));
    let customConsumers = JSON.stringify(sessionStorage.getItem('custom-consumer'));
    this.customConsumer = JSON.parse(customConsumers);
  }
  
  scrollToBottom() {
    try {
        this.scrollTable.nativeElement.scrollTop = this.scrollTable.nativeElement.scrollHeight;
    } catch (err) { }
}

  datainSertion() {
    let enrollData = {
      'question': this.userMessage,
      'session_id': this.users,
    }
    this.userMessage = ''
    this.loginService.newDataInsertion((enrollData)).subscribe((res: any) => {
      this.quertInput = res
      this.messages.push({ text:  res?.answer, isUser: false });
    })
  }

    
  formatMessage(text: string): string {
    return text
      .replace(/\n\n/g, '<br><br>') // Preserve double line breaks for spacing
      .replace(/\n/g, '<br>') // Convert single new lines to `<br>`
      .replace(/\d+\.\s\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold OEM names (e.g., GM, STELLANTIS)
      .replace(/-\s(.*?)\n/g, '• $1<br>') // Convert hyphens to bullet points
      .replace(
        /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, 
        '<a href="$2" target="_blank">$1</a>'
      ); // Convert markdown links [text](URL) into clickable links
  }
  
  removeSession() {
    const sessionId = this.users;
    const welcomeMessageIndex = this.messages.findIndex(message => message.text === 'Hi there! Thank you for visiting our workspace portal. How can I help you today?');
    this.messages.splice(welcomeMessageIndex + 1);
     this.loginService.removeSession(sessionId).pipe(finalize(() => {
          console.log('Session removed successfully');
        })
      )
      .subscribe((response) => {
          console.log('Session removed successfully', response);
        },
        (error) => {
          console.error('Error removing session', error);
        }
      );
  }

  chatBotOpen() {
  this.router.navigate(['/adlp/admin/admindashboard/chatBot'])
  }

  isMinimized: boolean = false;

  minimizeChatbot() {
    this.isMinimized = !this.isMinimized;
    
    if (this.isMinimized) {
      // Remove modal backdrop
      document.querySelector('.modal-backdrop')?.classList.add('d-none');
    } else {
      // Show modal backdrop again
      document.querySelector('.modal-backdrop')?.classList.remove('d-none');
    }
  }
}
